(function(angular, numeral) {
    'use strict';

    angular.module('aprima-core').constant('numeral', numeral);

})(window.angular, window.numeral);
